import type { IconData } from '@stacksjs/iconify-core'

export const filter1Solid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M24 4.5c-11.498 0-17.164.486-19.65.806c-1.722.22-2.85 1.692-2.85 3.3v3.2c0 1.315.47 2.62 1.422 3.616c1.947 2.032 6.533 6.49 13.128 10.838a.54.54 0 0 1 .243.397c.638 6.87 1.222 11.569 1.534 13.89a3.41 3.41 0 0 0 3.389 2.953c.645 0 1.276-.18 1.823-.522l5.027-3.136c1.06-.661 1.91-1.71 2.194-3.048c.336-1.582.86-4.629 1.423-10.122a.55.55 0 0 1 .244-.396c6.607-4.355 11.202-8.82 13.15-10.855c.954-.995 1.423-2.3 1.423-3.615v-3.2c0-1.608-1.128-3.08-2.85-3.3C41.164 4.986 35.498 4.5 24 4.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default filter1Solid
